import React, { Component, ComponentType } from 'react';
import styled from 'styled-components';

import { Table as AntDesignTable } from 'antd';
import { TableProps } from 'antd/lib/table';

const StyledTable = (styled(AntDesignTable)`
    margin: 24px auto;

    .ant-table-title,
    .total-cell {
        color: rgba(0, 0, 0, 0.85);
        background: #fafafa;
        font-weight: 500;
        text-align: center;
    }
` as ComponentType) as new <T>() => AntDesignTable<T>;

export class Table<T> extends Component<TableProps<T>> {
    render() {
        return <StyledTable<T> {...this.props} size="middle" pagination={false} bordered={true} />;
    }
}
